import { app } from '../../../../app';
import { Controller } from './license-activities.controller';

app.component('licenseActivities', {
    bindings:{
        activities: '<',
    },
    controller: Controller,
    templateUrl: require('./license-activities.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/activities/license-activities.component.js